var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-dependency-injection";
import { EntityTypeConfigurationHelper } from '../models/basics/basics.models';
import { BaseWidgetConfiguration } from "./base-widget";
import { transient } from "aurelia-dependency-injection";
import * as Enumerable from 'linq';
var EntityFinderWidgetConfiguration = /** @class */ (function (_super) {
    __extends(EntityFinderWidgetConfiguration, _super);
    function EntityFinderWidgetConfiguration(entityTypeConfigurationHelper) {
        return _super.call(this, entityTypeConfigurationHelper) || this;
    }
    EntityFinderWidgetConfiguration.prototype.getModel = function (self) {
        var e_1, _a;
        var list = new Array();
        try {
            for (var _b = __values(self.entityTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (item.isVisible) {
                    list.push(item);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return list;
    };
    EntityFinderWidgetConfiguration.prototype.entityTypeChanged = function () { };
    EntityFinderWidgetConfiguration.prototype.setModel = function (model) {
        var e_2, _a;
        var _loop_1 = function (item) {
            item.isVisible = Enumerable.from(model).any(function (x) { return x.uri && x.uri === item.uri; });
        };
        try {
            for (var _b = __values(this.entityTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                _loop_1(item);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    EntityFinderWidgetConfiguration = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EntityTypeConfigurationHelper])
    ], EntityFinderWidgetConfiguration);
    return EntityFinderWidgetConfiguration;
}(BaseWidgetConfiguration));
export { EntityFinderWidgetConfiguration };
